import { FC } from 'react'

import PurchaseScheduleProvider from './PurchaseScheduleProvider'

const DashboardProviders: FC = ({ children }) => {
  return <PurchaseScheduleProvider>{children}</PurchaseScheduleProvider>
}

export default DashboardProviders
